"use client";

const footerLinks = [
  { label: "Features", href: "/#features" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "Use Cases", href: "/#use-cases" },
  { label: "Pricing", href: "/#pricing" },
  { label: "FAQs", href: "/#faqs" },
  { label: "Contact", href: "/contact" },
];

const legalLinks = [
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Security Policy", href: "/security" },
  { label: "Accessibility", href: "/accessibility" },
  { label: "Service Level Agreement", href: "/sla" },
  { label: "Cancellation Policy", href: "/cancellation" },
  { label: "Service Limitations", href: "/service-limitations" },
  { label: "Messaging Compliance", href: "/messaging-compliance" },
];

export default function Footer() {
  return (
    <footer
      style={{
        background: "var(--color-bg-darker)",
        padding: "64px 24px 40px",
        color: "rgba(255,255,255,0.6)",
      }}
    >
      <div
        className="section-inner footer-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "1.5fr 1fr 1fr 1fr",
          gap: 48,
        }}
      >
        {/* Brand col */}
        <div>
          <p
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: "1.3rem",
              color: "#fff",
              marginBottom: 12,
            }}
          >
            EthnicPath <span style={{ opacity: 0.6 }}>Virtual</span>
          </p>
          <p
            style={{
              fontSize: "0.88rem",
              fontWeight: 300,
              lineHeight: 1.7,
              marginBottom: 20,
              maxWidth: 320,
            }}
          >
            AI voice agents for call centers and market research agencies.
            Automated calling, follow-up, reminders, multilingual outreach,
            and scalable customer interaction workflows.
          </p>
          <p style={{ fontSize: "0.78rem", opacity: 0.5 }}>
            Powered by EthnicPath Research
          </p>
        </div>

        {/* Nav col */}
        <div>
          <p style={colHeadStyle}>Navigation</p>
          <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 10 }}>
            {footerLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  style={footerLinkStyle}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = "rgba(255,255,255,0.6)")
                  }
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Legal col */}
        <div>
          <p style={colHeadStyle}>Legal</p>
          <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 10 }}>
            {legalLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  style={footerLinkStyle}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.color = "rgba(255,255,255,0.6)")
                  }
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact col */}
        <div>
          <p style={colHeadStyle}>Contact</p>
          <a
            href="mailto:support@ethnicpath.com"
            style={{
              ...footerLinkStyle,
              display: "block",
              marginBottom: 10,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.color = "rgba(255,255,255,0.6)")
            }
          >
            support@ethnicpath.com
          </a>
          <a
            href="/contact"
            style={footerLinkStyle}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.color = "rgba(255,255,255,0.6)")
            }
          >
            Contact Form →
          </a>
        </div>
      </div>

      {/* Easter egg mascot — generated with Higgsfield (nano_banana_flash) */}
      <div
        aria-hidden="true"
        title="Shhh, fox is sleeping 🦊"
        style={{
          maxWidth: 1200,
          margin: "32px auto 0",
          display: "flex",
          justifyContent: "center",
          opacity: 0.38,
          transition: "opacity 0.4s ease",
          cursor: "default",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.38")}
      >
        <img
          src="/easter-egg-fox.png"
          alt=""
          width={84}
          height={84}
          style={{ display: "block" }}
        />
      </div>

      {/* Bottom line */}
      <div
        style={{
          maxWidth: 1200,
          margin: "40px auto 0",
          paddingTop: 24,
          borderTop: "1px solid rgba(255,255,255,0.08)",
          textAlign: "center",
          fontSize: "0.78rem",
          color: "rgba(255,255,255,0.35)",
        }}
      >
        © {new Date().getFullYear()} EthnicPath Virtual. All rights reserved.
      </div>
    </footer>
  );
}

const colHeadStyle: React.CSSProperties = {
  fontSize: "0.78rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  color: "rgba(255,255,255,0.4)",
  marginBottom: 16,
};

const footerLinkStyle: React.CSSProperties = {
  color: "rgba(255,255,255,0.6)",
  textDecoration: "none",
  fontSize: "0.88rem",
  fontWeight: 300,
  transition: "color 0.2s",
};

